export default __webpack_public_path__ + "static/media/overlord_big.03851c75.jpg";